/**
 * Portal identifiers used when enqueueing RPA / write-back jobs to RabbitMQ.
 *
 * @module portalIdsForRabbitMq
 */

/** Known portal ids for queue routing and backend correlation. */
export enum PortalIdForRabbitMq {
  ONCOEMR = "oncoemr",
  CMM = "cmm",
  HEALTHFIRST_NAR = "availity_health_first_nar",
  BCBS_NAR = "availity_bcbs_nar",
}
